import { TWarehouse } from '@helpers/validation-schemas/warehouse-and-inventory/warehouse.schema';

const textColor = 'text-primary-dark';

const WarehouseDetail = (props: { warehouse: TWarehouse }) => {
    const { warehouse } = props;

    if (!warehouse) {
        return <div>No record found.</div>;
    }

    return (
        <div className="grid w-full grid-cols-2 gap-y-8">
            <div>
                <h5 className="mb-[0.70rem]">{warehouse.warehouse_type == 1 ? "Warehouse ID" :'Allocation Account ID'}</h5>
                <p className={textColor}>{warehouse.warehouse_id || '-'}</p>
            </div>
            <div>
                <h5 className="mb-[0.70rem]">{warehouse.warehouse_type == 1 ? "Warehouse Name" :'Allocation Account Name'}</h5>
                <p className={textColor}>{warehouse.warehouse_name || '-'}</p>
            </div>
            {/* <div>
                <h5 className="mb-[0.70rem]">Allocation Account Type</h5>
                <p className={textColor}>{warehouse.warehouse_type == "1" ? "Physical" : "Non-Physical" || '-'}</p>
            </div> */}
            <div>
                <h5 className="mb-[0.70rem]">
                    {warehouse.warehouse_type == 1 ? "Warehouse Phone Number" :'Allocation Account Phone Number'}
                </h5>
                <p className={textColor}>{warehouse.warehouse_phone1 || '-'}</p>
            </div>
            <div>
                <h5 className="mb-[0.70rem]">{warehouse.warehouse_type == 1 ? "Warehouse Email" :'Allocation Account Email'}</h5>
                <p className={textColor}>{warehouse.warehouse_email || '-'}</p>
            </div>
            <div>
                <h5 className="mb-[0.70rem]">Contact Person  Name</h5>
                <p className={textColor}>
                    {warehouse.contact_first_name || '-'}
                </p>
            </div>
            {/* <div>
                <h5 className="mb-[0.70rem]">Contact Person Last Name</h5>
                <p className={textColor}>
                    {warehouse.contact_last_name || '-'}
                </p>
            </div> */}
            <div>
                <h5 className="mb-[0.70rem]">Contact Person Phone Number</h5>
                <p className={textColor}>{warehouse.contact_phoneno || '-'}</p>
            </div>
            {/* <div>
                <h5 className="mb-[0.70rem]">Contact Person Email</h5>
                <p className={textColor}>{warehouse.contact_email || '-'}</p>
            </div> */}
            {/* <div>
                <h5 className="mb-[0.70rem]">Country Name</h5>
                <p className={textColor}>
                    {warehouse.warehouse_country_name || '-'}
                </p>
            </div> */}
            {
                warehouse.warehouse_type == 1 && (
                   <>
                     <div>
                <h5 className="mb-[0.70rem]">Division/State Name</h5>
                <p className={textColor}>
                    {warehouse.warehouse_division_name ||
                        warehouse.warehouse_state_name ||
                        '-'}
                </p>
            </div>
            <div>
                <h5 className="mb-[0.70rem]">City Name</h5>
                <p className={textColor}>
                    {warehouse.warehouse_city_name || '-'}
                </p>
            </div>
            <div>
                <h5 className="mb-[0.70rem]">Township Name</h5>
                <p className={textColor}>
                    {warehouse.warehouse_township_name || '-'}
                </p>
            </div>
            {/* <div>
                <h5 className="mb-[0.70rem]">Township Name</h5>
                <p className={textColor}>
                    {warehouse.warehouse_township_name || '-'}
                </p>
            </div> */}
            <div>
                <h5 className="mb-[0.70rem]">Address</h5>
                <p className={textColor}>
                    {warehouse.warehouse_address || '-'}
                </p>
            </div>
                   </>
                )
            }
            
            {/* <div>
                <h5 className="mb-[0.70rem]">Remark</h5>
                <p className={textColor}>{warehouse.remark || '-'}</p>
            </div> */}
            <div>
                <h5 className="mb-[0.70rem]">Description</h5>
                <p className={textColor}>{warehouse.description || '-'}</p>
            </div>
           
            {/* <div>
                <h5 className="mb-[0.70rem]">Address</h5>
                <p className={textColor}>
                    {warehouse.warehouse_address || '-'}
                </p>
            </div> */}
            {/* <div>
                <h5 className="mb-[0.70rem]">Remark</h5>
                <p className={textColor}>{warehouse.remark || '-'}</p>
            </div> */}
            {/* <div>
                <h5 className="mb-[0.70rem]">Description</h5>
                <p className={textColor}>{warehouse.description || '-'}</p>
            </div> */}
        </div>
    );
};

export default WarehouseDetail;
